// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"b5a96c3f","760":"db165e01"}[chunkId] + ".chunk.css";
};